import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../api';

const ASSETS = {
    treeBg: '/tree.png',
    leadersFg: '/image.png',
};

const THEME_COLOR = '#C0722C';
const BG_COLOR = '#F3F0E7';

const LoginScreen = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [mode, setMode] = useState('SIGN_IN'); // SIGN_IN, OTP_VERIFY, FORGOT_PASSWORD, RESET_PASSWORD, SIGN_UP(Removed)
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        localStorage.clear();
        injectStyles();
    }, []);

    const customSwal = Swal.mixin({
        customClass: {
            confirmButton: 'swal-confirm-btn',
            cancelButton: 'swal-cancel-btn',
            input: 'swal-input-otp'
        },
        buttonsStyling: false,
    });

    const injectStyles = () => {
        const style = document.createElement('style');
        style.innerHTML = `
      .swal-confirm-btn {
        background-color: ${THEME_COLOR} !important;
        color: white !important;
        padding: 12px 30px !important;
        border-radius: 12px !important;
        border: none !important;
        outline: none !important;
        font-weight: 600 !important;
        cursor: pointer !important;
        margin: 10px !important;
        font-size: 16px !important;
        box-shadow: 0 4px 15px rgba(192, 114, 44, 0.3) !important;
        transition: all 0.3s ease !important;
      }
      .swal-confirm-btn:focus {
        outline: none !important;
        border: none !important;
        box-shadow: 0 4px 15px rgba(192, 114, 44, 0.4) !important;
      }
      .swal-cancel-btn {
        background-color: #ffffff !important;
        color: ${THEME_COLOR} !important;
        border: 1.5px solid ${THEME_COLOR} !important;
        padding: 12px 30px !important;
        border-radius: 12px !important;
        font-weight: 600 !important;
        cursor: pointer !important;
        margin: 10px !important;
        font-size: 16px !important;
        outline: none !important;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05) !important;
        transition: all 0.3s ease !important;
      }
      .swal-cancel-btn:hover {
        background-color: #FFF5EB !important;
        box-shadow: 0 6px 15px rgba(192, 114, 44, 0.2) !important;
        transform: translateY(-1px) !important;
      }
      .swal-cancel-btn:focus {
        outline: none !important;
        box-shadow: 0 0 0 3px rgba(192, 114, 44, 0.2) !important;
      }
      .swal-input-otp {
        border-radius: 10px !important;
        border: 1px solid #E5E5E5 !important;
        font-size: 18px !important;
        text-align: center !important;
        letter-spacing: 5px !important;
        padding: 10px !important;
        width: 80% !important;
        margin: 0 auto !important;
      }
      /* Custom Input Class - Ensuring consistent styling */
      .custom-input {
        width: 100%;
        padding: 16px 20px;
        border-radius: 12px;
        border: 1.5px solid #E5E5E5;
        font-size: 16px;
        box-sizing: border-box;
        outline: none;
        transition: all 0.3s ease;
        background-color: #FAFAFA;
        font-family: inherit;
        color: #333;
        -webkit-appearance: none;
        appearance: none;
      }
      .custom-input:focus {
        border-color: ${THEME_COLOR};
        box-shadow: 0 0 0 4px rgba(192, 114, 44, 0.1);
        background-color: #fff;
      }
      /* Autofill Fix for Chrome/Safari */
      input:-webkit-autofill,
      input:-webkit-autofill:hover, 
      input:-webkit-autofill:focus, 
      input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px #FAFAFA inset !important;
        -webkit-text-fill-color: #333 !important;
        transition: background-color 5000s ease-in-out 0s;
      }
      input:-webkit-autofill:focus {
        -webkit-box-shadow: 0 0 0 30px #fff inset !important;
      }
    `;
        document.head.appendChild(style);
    };

    const styles = {
        container: {
            backgroundColor: BG_COLOR,
            minHeight: '100vh',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontFamily: '"Outfit", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            padding: '20px',
            boxSizing: 'border-box',
        },
        contentWrapper: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '120px',
            maxWidth: '1200px',
            width: '100%',
        },
        leftSection: {
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            color: '#333',
        },
        imageContainer: {
            position: 'relative',
            width: '450px',
            height: '350px',
            marginBottom: '30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        treeImage: {
            position: 'absolute',
            top: '0',
            left: '50%',
            transform: 'translateX(-50%)',
            height: '280px',
            width: 'auto',
            opacity: '0.2',
            zIndex: 1,
        },
        leadersImage: {
            position: 'absolute',
            bottom: '0',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
            height: 'auto',
            zIndex: 2,
        },
        mainTitle: {
            fontSize: '40px',
            fontWeight: '700',
            margin: '0 0 5px 0',
            color: '#222',
            lineHeight: '1.2'
        },
        subTitle: {
            fontSize: '18px',
            color: '#666',
            margin: '0',
            fontWeight: '400'
        },
        cardSection: {
            width: '100%',
            maxWidth: '500px',
        },
        loginCard: {
            backgroundColor: '#FFFFFF',
            borderRadius: '32px',
            padding: '60px 40px', /* Reduced horizontal padding slightly */
            boxShadow: '0px 20px 60px rgba(0, 0, 0, 0.08)',
            textAlign: 'center',
        },
        cardHeader: {
            fontSize: '30px',
            fontWeight: '700',
            marginBottom: '10px',
            color: '#222',
            textTransform: 'uppercase',
        },
        cardSubHeader: {
            fontSize: '15px',
            color: '#777',
            marginBottom: '40px',
        },
        formGroup: {
            marginBottom: '20px',
            textAlign: 'left',
        },
        label: {
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#444',
            marginBottom: '8px',
            marginLeft: '2px'
        },
        forgotPasswordLink: {
            display: 'inline-block',
            width: '100%',
            textAlign: 'right',
            fontSize: '13px',
            color: THEME_COLOR,
            textDecoration: 'none',
            marginTop: '-10px',
            marginBottom: '30px',
            fontWeight: '600',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            padding: 0,
        },
        actionButton: {
            width: '100%',
            padding: '16px',
            backgroundColor: THEME_COLOR,
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(192, 114, 44, 0.3)',
            marginTop: '10px'
        },
        secondaryAction: {
            marginTop: '25px',
            fontSize: '14px',
            color: '#555',
        },
        toggleLink: {
            color: THEME_COLOR,
            cursor: 'pointer',
            fontWeight: '700',
            marginLeft: '5px'
        },
        cardFooter: {
            marginTop: '35px',
            fontSize: '14px',
            color: '#333',
        },
        contactLink: {
            color: THEME_COLOR,
            textDecoration: 'none',
            fontWeight: '700',
        }
    };

    const handleSignIn = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post(`${API_BASE_URL}/api/signin`, { email, password });
            customSwal.fire({
                icon: 'success',
                title: 'Credentials Verified',
                text: 'OTP sent to your email.',
                timer: 1500,
                showConfirmButton: false
            });
            setMode('OTP_VERIFY');
        } catch (err) {
            customSwal.fire({
                icon: 'error',
                title: 'Sign In Failed',
                text: err.response?.data?.error || 'Invalid credentials'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOTP = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await axios.post(`${API_BASE_URL}/api/verify-otp`, { email, otp });

            const role = data.user.role;

            // Check if user is Speaker or Leader - they should use mobile app
            if (role === 'Speaker' || role === 'MLA' || role === 'MP' || role === 'MLC') {
                localStorage.clear(); // Clear any stored data
                setLoading(false);
                customSwal.fire({
                    icon: 'info',
                    title: 'Mobile App Access Required',
                    html: `
                        <div style="text-align: center; padding: 10px;">
                            <p style="font-size: 16px; color: #555; margin-bottom: 15px;">
                                Your profile (<strong>${role}</strong>) is configured for mobile access only.
                            </p>
                            <p style="font-size: 14px; color: #777;">
                                Please download and use the <strong>Bihar Vidhan Sabha Mobile App</strong> to access your dashboard.
                            </p>
                        </div>
                    `,
                    confirmButtonText: 'Understood',
                    allowOutsideClick: false
                }).then(() => {
                    // Reset to sign-in mode
                    setMode('SIGN_IN');
                    setEmail('');
                    setPassword('');
                    setOtp('');
                });
                return; // Exit the function
            }

            // For allowed roles, proceed with login
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));

            customSwal.fire({
                icon: 'success',
                title: 'Secure Session Established',
                text: 'Welcome to Bihar Vidhan Sabha Dashboard',
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                let path = '/home';

                switch (role) {
                    case 'SuperAdmin':
                        path = '/admin/dashboard';
                        break;
                    case 'MLA':
                    case 'MLC':
                        path = '/legislator/dashboard';
                        break;
                    case 'Minister':
                        path = '/minister/dashboard';
                        break;
                    case 'Secretary':
                    case 'Secretariat':
                        path = '/secretariat/dashboard';
                        break;
                    case 'Staff':
                        path = '/secretariat/dashboard'; // Staff also goes here for now as per requirement
                        break;
                    default:
                        path = '/home';
                }
                navigate(path);
            });
        } catch (err) {
            customSwal.fire('Error', err.response?.data?.error || 'Invalid OTP', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleForgotPassEmail = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post(`${API_BASE_URL}/api/forgot-password`, { email });
            customSwal.fire({
                icon: 'success',
                title: 'OTP Sent!',
                text: 'Check your email for reset instructions.'
            });
            setMode('RESET_PASSWORD');
        } catch (err) {
            customSwal.fire({
                icon: 'error',
                title: 'Error',
                text: err.response?.data?.error || 'Failed to send reset OTP'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post(`${API_BASE_URL}/api/reset-password`, { email, otp, newPassword });
            customSwal.fire({
                icon: 'success',
                title: 'Password Updated!',
                text: 'Please sign in with your new password.'
            });
            setMode('SIGN_IN');
        } catch (err) {
            customSwal.fire({
                icon: 'error',
                title: 'Error',
                text: err.response?.data?.error || 'Update failed'
            });
        } finally {
            setLoading(false);
        }
    };

    const renderForm = () => {
        switch (mode) {
            case 'SIGN_IN':
                return (
                    <form onSubmit={handleSignIn}>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Official Credentials</label>
                            <div style={{ position: 'relative' }}>
                                {/* <span style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: THEME_COLOR, display: 'flex' }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                </span> */}
                                <input
                                    type="email"
                                    placeholder="Official Email Domain"
                                    className="custom-input"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <div style={styles.formGroup}>
                            <div style={{ position: 'relative' }}>
                                {/* <span style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: THEME_COLOR, display: 'flex' }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                                </span> */}
                                <input
                                    type="password"
                                    placeholder="Encryption Password"
                                    className="custom-input"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <button type="button" onClick={() => setMode('FORGOT_PASSWORD')} style={styles.forgotPasswordLink}>Recovery Options?</button>
                        <button type="submit" style={styles.actionButton} disabled={loading}>
                            {loading ? 'VERIFYING...' : 'ESTABLISH SECURE SESSION'}
                        </button>
                        <p style={{ ...styles.secondaryAction, fontSize: '12px', opacity: 0.6 }}>
                            Restricted Access • Bureaucratic Authentication Protocol
                        </p>
                    </form>
                );
            case 'OTP_VERIFY':
                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            width: '60px',
                            height: '60px',
                            backgroundColor: '#FDF8F3',
                            borderRadius: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 25px',
                            color: THEME_COLOR,
                            boxShadow: '0 8px 16px rgba(192, 114, 44, 0.1)'
                        }}>
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                        </div>
                        <p style={{ color: '#888', marginBottom: '30px', fontSize: '14px', lineHeight: '1.5' }}>
                            A high-security verification code has been dispatched to <br />
                            <strong style={{ color: '#2C1A10' }}>{email}</strong>
                        </p>
                        <form onSubmit={handleVerifyOTP}>
                            <div style={styles.formGroup}>
                                <input
                                    type="text"
                                    placeholder="0 0 0 0 0 0"
                                    className="custom-input"
                                    value={otp}
                                    maxLength={6}
                                    onChange={(e) => setOtp(e.target.value)}
                                    required
                                    style={{
                                        textAlign: 'center',
                                        fontSize: '24px',
                                        fontWeight: '800',
                                        letterSpacing: '8px',
                                        backgroundColor: '#FDF8F3',
                                        borderColor: otp.length === 6 ? THEME_COLOR : '#EAE2D5'
                                    }}
                                />
                            </div>
                            <button type="submit" style={styles.actionButton} disabled={loading || otp.length < 6}>
                                {loading ? 'VERIFYING IDENTITY...' : 'AUTHORIZE ACCESS'}
                            </button>
                            <p style={{ ...styles.secondaryAction, marginTop: '20px' }}>
                                Back to <span onClick={() => setMode('SIGN_IN')} style={styles.toggleLink}>Sign In</span>
                            </p>
                        </form>
                    </div>
                );
            case 'FORGOT_PASSWORD':
                return (
                    <form onSubmit={handleForgotPassEmail}>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Registered Email ID</label>
                            <input
                                type="email"
                                placeholder="Enter Email ID"
                                className="custom-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" style={styles.actionButton} disabled={loading}>
                            Send Reset OTP
                        </button>
                        <p style={styles.secondaryAction}>
                            Back to <span onClick={() => setMode('SIGN_IN')} style={styles.toggleLink}>Sign In</span>
                        </p>
                    </form>
                );
            case 'RESET_PASSWORD':
                return (
                    <form onSubmit={handleResetPassword}>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Enter OTP</label>
                            <input
                                type="text"
                                placeholder="6-digit OTP"
                                className="custom-input"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                required
                            />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>New Password</label>
                            <input
                                type="password"
                                placeholder="New Password"
                                className="custom-input"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" style={styles.actionButton} disabled={loading}>
                            Reset Password
                        </button>
                    </form>
                );
            default: return null;
        }
    };

    return (
        <div style={styles.container}>
            <div id="content-wrapper" style={styles.contentWrapper}>

                {/* Left Section - Branding */}
                <div id="left-branding" style={styles.leftSection}>
                    <div id="left-images" style={styles.imageContainer}>
                        <img
                            src={ASSETS.treeBg}
                            alt="Decorative"
                            style={styles.treeImage}
                        />
                        <img
                            src={ASSETS.leadersFg}
                            alt="Leaders"
                            style={styles.leadersImage}
                        />
                    </div>
                    <div id="brand-text">
                        <h1 style={styles.mainTitle}>Bihar Vidhan Sabha</h1>
                        <p style={styles.subTitle}>Integrated Digital Assembly System</p>
                    </div>
                </div>

                {/* Right Section - Auth Form Card */}
                <div style={styles.cardSection}>
                    <div style={styles.loginCard}>
                        <h2 style={styles.cardHeader}>
                            {mode.startsWith('FORGOT') || mode.startsWith('RESET') ? 'RESET PASSWORD' : (mode === 'OTP_VERIFY' ? 'VERIFY OTP' : 'SIGN IN')}
                        </h2>
                        <p style={styles.cardSubHeader}>
                            {mode === 'SIGN_IN' ? 'Use Your Official Email and Password' :
                                mode === 'OTP_VERIFY' ? 'Secure Verification Required' : 'Follow steps for recovery'}
                        </p>

                        {renderForm()}

                        <div style={styles.cardFooter}>
                            Need Help ? <span style={{ ...styles.contactLink, cursor: 'pointer' }}>Contact Governance Support</span>
                        </div>
                    </div>
                </div>

            </div>

            <style>
                {`
          @media (max-width: 1100px) {
            #content-wrapper { gap: 60px !important; }
          }
          @media (max-width: 992px) {
            #content-wrapper {
              flex-direction: column !important;
              gap: 30px !important;
            }
            #left-images { display: none !important; }
            #left-branding { 
                display: flex !important;
                margin-bottom: 10px !important;
                width: 100% !important;
            }
            #brand-text {
                margin-top: 0 !important;
                text-align: center !important;
            }
            h1[style*="font-size: 40px"] { font-size: 28px !important; margin-bottom: 5px !important; }
            p[style*="font-size: 18px"] { font-size: 14px !important; }
            
            div[style*="justify-content: center"] { justify-content: center !important; }
            div[style*="max-width: 500px"] { max-width: 400px !important; width: 100% !important; }
          }
          @media (max-width: 576px) {
            div[style*="padding: 60px 40px"] { padding: 30px 20px !important; }
            h2[style*="font-size: 30px"] { font-size: 22px !important; }
            div[style*="border-radius: 32px"] { border-radius: 20px !important; }
          }
        `}
            </style>
        </div>
    );
};

export default LoginScreen;
